import { getTheme as getSeiueTheme } from '@seiue/theme'

// 主题色
export const THEME_COLOR = '#01B3B3'

export declare type ColorScheme = {
  background: string
  backgroundLight: string
  text: string
  element?: string
  elementLight?: string
}

export declare type DefaultTheme = {
  brand: {
    text0: string
    _1: string
    _2: string
    _3: string
    _4: string
    _5: string
    dark1: string
  }
  background: {
    _0: string
    _1: string
    _2: string
    _3: string
    _4: string
    _5: string
    _6: string
  }
  text: {
    _1: string
    _2: string
    _3: string
    _4: string
    _0: string
    brand: string
  }
  border: {
    readonly greyLight: '#F0F5F5'
    readonly greyNormal: '#E1EBF0'
    readonly greyDark: '#AFBDC7'
  }
  status: {
    success: ColorScheme & {
      element: string
    }
    ongoing: ColorScheme & {
      element: string
    }
    warning: ColorScheme & {
      element: string
    }
    danger: ColorScheme & {
      element: string
    }
    invalid: ColorScheme & {
      element: string
    }
  }
}

export const getTheme = (themeColor?: string): DefaultTheme => {
  const seiueTheme = getSeiueTheme(themeColor || THEME_COLOR)
  return {
    ...seiueTheme,
    background: {
      _5: '#fff',
      _4: '#F5FaFa',
      _3: '#F0F5F5',
      _2: '#E1EBF0',
      _1: '#AFBDC7',
      _0: '#475866',
      _6: 'rgba(21, 37, 41, 0.6)',
    },
    text: {
      _0: '#fff',
      _4: '#AFBDC7',
      _3: '#718999',
      _2: '#455766',
      _1: '#152529',
      brand: seiueTheme.brand._1,
    },
    border: {
      greyLight: '#F0F5F5',
      greyNormal: '#E1EBF0',
      greyDark: '#AFBDC7',
    },
    status: {
      ...seiueTheme.status,
      success: {
        background: '#B2F5BB',
        backgroundLight: '#E8FFEA',
        text: '#00CC36',
        element: '#00CC36',
        elementLight: '#2DE057',
      },
      warning: {
        background: '#FFE8BA',
        backgroundLight: '#FFF8E8',
        text: '#FF8800',
        element: '#FF8800',
        elementLight: '#FFA52E',
      },
      danger: {
        background: '#FDCDC5',
        backgroundLight: '#FFECE8',
        text: '#F54545',
        element: '#F54545',
        elementLight: '#F76560',
      },
    },
  }
}
